<div class="headerReservation__cont">
  <app-ds-header
    [type]="dsHeaderConfig?.type"
    [widgetConfig]="widgets$ | async"
    (clickAction)="widgetClicked.emit($event)">
  </app-ds-header>
</div>